export default "__VITE_ASSET__699e2a7d__"